import { translations } from "../../Translation/staticTranslation";

const lang = localStorage.getItem("language") || "ar";
const productTable = translations[lang]?.productPage?.productTableCol;
export const productColumns = [
  {
    label: productTable?.product_name || "PRODUCT NAME",
    dataKey: lang === "ar" ? "name_arabic" : "name_english",
  },
  {
    label: productTable?.category || "CATEGORY",
    dataKey: lang === "ar" ? "category_arabic" : "category",
  },
  { label: productTable?.price || "PRICE", dataKey: "price_amount" },
  { label: productTable?.image || "IMAGE", dataKey: "image_url" },
  { label: productTable?.product_url || "PRODUCT URL", dataKey: "product_url" },
  { label: productTable?.status || "STATUS", dataKey: "is_active" },
];
